import { render } from "./Internship.vue?vue&type=template&id=5345c046&scoped=true"
import script from "./Internship.vue?vue&type=script&lang=js"
export * from "./Internship.vue?vue&type=script&lang=js"

import "./Internship.vue?vue&type=style&index=0&id=5345c046&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5345c046"

export default script